export const tableItemsNames = [
  'Address',
  'Contact',
  'Status',
  'Claim',
  'File',
  'Policy',
  'Date of loss',
  'Inspection',
]

export const submittedStatus = 'submitted'
export const inProgressStatus = 'in progress'
export const newStatus = 'new'

export const colorForStatuses = {
  [newStatus]: '#DCEDC8',
  [inProgressStatus]: '#FFE57F',
}

export const adjustersFlowName = 'adjusters'

export const adjustersRoute = `/${adjustersFlowName}`

export const firestoreStepperPathName = 'Steps State'
export const firestoreClaimsPathName = 'Claims'
